import { TableColumn } from '../../shared/table/table.component';

export const expirationStudioEN = {
  EXPIRATION_NAME: 'Name',
  EXPIRATION_TYPE: 'Expiration type',
  EXPIRATION_DATE: 'Expiration date',
  EXPIRATION_STATUS: 'Expiration status',
  COMPANY: 'Company',
  DELETE: 'Delete',
  EDIT: 'Edit',
  ACTIONS: 'Actions',
  RESOLVED: 'Resolved',
};

export const expirationStudioES = {
  EXPIRATION_NAME: 'Nombre',
  EXPIRATION_TYPE: 'Tipo de vencimiento',
  EXPIRATION_DATE: 'Fecha del vencimiento',
  EXPIRATION_STATUS: 'Estado del vencimiento',
  COMPANY: 'Sociedad',
  DELETE: 'Eliminar',
  EDIT: 'Editar',
  VINCULATE: 'Vincular',
  ACTIONS: 'Acciones',
  RESOLVED: 'Resuelto',
};

export const ColumnsExpirations: TableColumn[] = [
  {
    field: 'name',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_NAME',
    type: 'regular',
  },
  {
    field: 'expiration_date',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_DATE',
    type: 'date-badge',
  },
  {
    field: 'company',
    caption: 'EXP_STUDIO_TABLE.COMPANY',
    type: 'link',
    linkToRedirectTo: '/company/',
    fieldOfRedirection: 'company_id',
  },
  {
    field: 'expiration_range',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_STATUS',
    type: 'badge',
    colorField: 'expiration_range_id',
    translate: true,
    badgeVariants: {
      1: 'danger',
      2: 'warning',
      3: 'warning',
      4: 'success',
    },
    emptyLabel: 'LABELS.NO_STATUS',
  },
  {
    field: 'expiration_type',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_TYPE',
    type: 'badge',
    translate: true,
    badgeVariants: {},
    emptyLabel: 'LABELS.NO_TYPE',
  },
  {
    field: 'has_files',
    type: 'icon-multi-action',
    caption: 'EXP_STUDIO_TABLE.ACTIONS',

    multiActionIcons: [
      {
        actionType: 'resolve',
        icon: 'done',
        actionTitle: 'EXP_STUDIO_TABLE.RESOLVED',
        conditional: true,
        fieldOfCondition: 'resolvable',
      },
      {
        actionType: 'linkDocs',
        icon: 'link',
        actionTitle: 'EXP_STUDIO_TABLE.VINCULATE',
        conditional: true,
        fieldOfCondition: 'deletable',
      },
      {
        actionType: 'delete',
        icon: 'delete_forever',
        actionTitle: 'EXP_STUDIO_TABLE.DELETE',
        conditional: true,
        fieldOfCondition: 'deletable',
      }
    ],
  },
];

export const expirationByCompanyTable: TableColumn[] = [
  {
    field: 'name',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_NAME',
    type: 'regular',
  },
  {
    field: 'expiration_date',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_DATE',
    type: 'date-badge',
  },
  {
    field: 'expiration_type',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_TYPE',
    type: 'badge',
    translate: true,
    badgeVariants: {},
    emptyLabel: 'LABELS.NO_TYPE',
  },
  {
    field: 'expiration_range',
    caption: 'EXP_STUDIO_TABLE.EXPIRATION_STATUS',
    type: 'badge',
    colorField: 'expiration_range_id',
    translate: true,
    badgeVariants: {
      1: 'danger',
      2: 'warning',
      3: 'warning',
      4: 'success',
    },
    emptyLabel: 'LABELS.NO_STATUS',
  },
  {
    field: 'has_files',
    type: 'icon-multi-action',
    caption: 'EXP_STUDIO_TABLE.ACTIONS',

    multiActionIcons: [
      {
        actionType: 'resolve',
        icon: 'done',
        actionTitle: 'EXP_STUDIO_TABLE.RESOLVED',
        conditional: true,
        fieldOfCondition: 'resolvable',
      },
      {
        actionType: 'linkDocs',
        icon: 'link',
        actionTitle: 'EXP_STUDIO_TABLE.VINCULATE',
        conditional: true,
        fieldOfCondition: 'deletable',
      },
      {
        actionType: 'delete',
        icon: 'delete_forever',
        actionTitle: 'EXP_STUDIO_TABLE.DELETE',
        conditional: true,
        fieldOfCondition: 'deletable',
      },
    ],
  },
];
